<template>
    <el-form>
        <el-form-item>
            <div>编号：{{value?value:''}}</div>
            <div v-if="optionValue == '0'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arrProp0" :key="item.id" :label="item.id +'-' +$t(item.name)" :value="item.id">
                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id+'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>

                        <span style="float: right">{{ $t(item.name) }}</span>
                    </el-option>
                </el-select>
            </div>
            <div v-if="optionValue == '5'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arrConditionProp" :key="item.id" :label="item.id +'-' +$t(item.name)" :value="item.id">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>
            <div v-if="optionValue == '1'">
                <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in monsterConfigs" :key="item.id" :label="item.id +'-' + $t(item.name)"
                               :value="item.id">
                        <el-image style="width: 30px; height: 30px; float: left" :src="'./static/monster_icon/'+item.id+'.png'"
                                  fit="cover"></el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>
                    </el-option>
                </el-select>
            </div>
            <div v-if="optionValue == '2'">
                <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in monsterConfigs" :key="item.id + 10000" :label="(item.id + 10000) +'-' + $t(item.name) + $t('reward_editor.4')"
                               :value="item.id + 10000">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+(item.id + 10000)+'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) + $t('reward_editor.4') }}</span>

                    </el-option>
                </el-select>
            </div>
            <div v-if="optionValue == '3'">
                <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp3" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>
            <div v-if="optionValue == '4'">
                <el-select v-model="value" filterable :placeholder='$t("reward_editor.2")' @change="onEmblemTypeChange">
                    <el-option v-for="item in arrProp4" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">
                    </el-option>
                </el-select>
                <div v-if="!emblemRandomByQuality">
                    <el-divider></el-divider>
                    <el-row>
                        <!--主属性-->
                        <el-col :lg="8">
                            <div>{{$t('reward_editor.5')}}:</div>
                        </el-col>
                        <el-col>
                            <el-select v-model="emblemMainProperty" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                                <el-option v-for="item in emblemMainConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row>
                        <!--品质-->
                        <el-col :lg="8"><div>{{$t('reward_editor.6')}}:</div></el-col>
                        <el-col>
                            <el-select v-model="emblemQuality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="" @change="onEmblemQualityChange">
                                <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-divider></el-divider>
                    <el-row>
                        <!--等级-->
                        <el-col :lg="4">
                            <div>{{$t('reward_editor.7')}}:
                                <el-input-number v-model="emblemLevel" :min="1" :max="150" :label="$t('reward_editor.8')" @change="onEmblemLevelChange"></el-input-number>
                            </div>
                        </el-col>
                        <!--阶段-->
                        <el-col :lg="4">
                            <div>{{$t('reward_editor.9')}}:
                                <el-input-number v-model="emblemStage" :min="0" :max="20" :disabled="true" :label="$t('reward_editor.10')"></el-input-number>
                            </div>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <!--宿命-->
                    <div>{{$t('reward_editor.11')}}：</div>
                    <div>
                        <el-select v-model="emblemFate" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                            <el-option v-for="item in emblemFateOptions" :key="item.value" :label="$t(item.label)" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div v-if="emblemFate===2">
                        <el-select v-model="emblemFateProperty" filterable :placeholder='$t("reward_editor.2")' value="">
                            <el-option v-for="item in emblemFateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div v-if="emblemFate===3">
                        <el-row>
                            <el-col>
                                宿命出现概率(百分比):
                            </el-col>
                            <el-col :lg="12">
                                <el-slider
                                    v-model="emblemFateCustomize"
                                    show-input input-size="mini">
                                </el-slider>
                            </el-col>
                            <el-col>
                                <div class="block">
                                    <div>
                                        <el-col>
                                            选择宿命效果:
                                        </el-col>
                                        <el-select v-model="editEmblemFateProperty" filterable :placeholder='$t("reward_editor.2")' value="">
                                            <el-option v-for="item in emblemFateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div>
                                        <el-col>
                                            配置权重:
                                        </el-col>
                                        <el-input-number v-model="editEmblemFateChance" :precision="2" :step="0.1" placeholder="请输入权重" ></el-input-number>
                                    </div>
                                    <div>
                                        <el-col>
                                            指定宿命品质:
                                        </el-col>
                                        <el-select v-model="editEmblemFateQuality" filterable :placeholder='$t("reward_editor.2")' value=0>
                                            <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div>
                                        <el-col>
                                            指定浮动值:
                                        </el-col>
                                        <el-input-number v-model="editEmblemFateRdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0></el-input-number>
                                    </div>
                                    <el-button @click="addEmblemFateChance">添加权重</el-button>
                                    <el-row>
                                        <el-col>
                                            结果集:
                                        </el-col>
                                        <el-tag v-for="(tag,idx) in emblemFateCustomizeTags" :key="idx" closable @close="deleteEmblemFateChance(idx)">{{$t(tag.data.name)}}-{{tag.chance}}-{{tag.quality}}-{{tag.rdFloat}}</el-tag>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-divider></el-divider>
                    <!--词条-->
                    <div>{{$t('reward_editor.14')}}：<span class="float-tip">浮动值,幅度白50%~60%（填0.5~0.6），绿60%~70%（填0.6~0.7），其他颜色同理</span></div>
<!--                    <div>
                        <el-row>
                            <el-col>
                                <el-button @click="addEmblemEntry">{{$t('reward_editor.15')}}</el-button>
                                <el-button @click="removeEmblemEntry">{{$t('reward_editor.16')}}</el-button>
                            </el-col>
                        </el-row>
                    </div>-->
                    <div v-if="editEmblemEntries[0].active===true">
                        <el-row>
                            <el-col>词条1：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[0].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[0].quality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[0].rdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="editEmblemEntries[1].active===true">
                        <el-row>
                            <el-col>词条2：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[1].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[1].quality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[1].rdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="editEmblemEntries[2].active===true">
                        <el-row>
                            <el-col>词条3：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[2].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[2].quality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[2].rdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="editEmblemEntries[3].active===true">
                        <el-row>
                            <el-col>词条4：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[3].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[3].quality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[3].rdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="editEmblemEntries[4].active===true">
                        <el-row>
                            <el-col>词条5：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[4].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[4].quality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[4].rdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="editEmblemEntries[5].active===true">
                        <el-row>
                            <el-col>词条6：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[5].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[5].quality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[5].rdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <el-divider></el-divider>
                </div>
            </div>

            <div v-if="optionValue == '6'">
                <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp6" :key="item.id + 20000" :label="(item.id + 20000) +'-' + $t(item.name) + $t('reward_editor.17')"
                               :value="item.id + 20000">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+(item.id + 20000)+'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>

                        <span style="float: right">{{ $t(item.name) + $t('reward_editor.17') }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '7'">
                <div>
                    <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                        <el-option v-for="item in arrProp7" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <span>战纹品质：</span>
                    <el-select v-model="warGrooveQuality" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                        <el-option v-for="item in wallGainQualityConfig" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <el-switch v-model="warGrooveChannelSwitch" active-text='固定通路' inactive-text='随机通路'>
                    </el-switch>

                    <div v-if="warGrooveChannelSwitch">
                        <div>
                            <span>上：</span>
                            <el-select v-model="warGrooveChannelUp" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                                <el-option v-for="item in warGrooveChannelOption" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <span>下：</span>
                            <el-select v-model="warGrooveChannelDown" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                                <el-option v-for="item in warGrooveChannelOption" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <span>左：</span>
                            <el-select v-model="warGrooveChannelLeft" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                                <el-option v-for="item in warGrooveChannelOption" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <span>右：</span>
                            <el-select v-model="warGrooveChannelRight" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                                <el-option v-for="item in warGrooveChannelOption" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="optionValue == '8'">
                <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp6" :key="item.id + 30000" :label="(item.id + 30000) +'-' + $t(item.name) + $t('reward_editor.18')"
                               :value="item.id + 30000">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+(item.id + 30000)+'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>

                        <span style="float: right">{{ $t(item.name) + $t('reward_editor.18') }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '9'">
                <el-select v-model="value" filterable :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp9" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '10'">
                <el-select v-model="value" filterable :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp10" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '11'">
                <el-select v-model="value" filterable :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp11" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '12'">
                <el-select v-model="value" filterable :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp12" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '13'">
                <!-- 宝箱-->
                <el-select v-model="value" filterable :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp13" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '14'">
                <el-select v-model="value" filterable :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp14" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '15'">
                <el-select v-model="value" filterable :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp15" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '17'">
              <!--起源盘-->
              <el-select v-model="value" filterable :placeholder='$t("reward_editor.2")'>
                <el-option v-for="item in arrProp17" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">
                </el-option>
              </el-select>
              <div>
                <el-divider></el-divider>
                <el-row>
                  <!--品质-->
                  <el-col :lg="8"><div>{{$t('reward_editor.6')}}:</div></el-col>
                  <el-col>
                    <el-select v-model="plateQuality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="" @change="plateQualityChange">
                      <el-option v-for="item in plateQualities" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                    <div v-if="plateQuality===-1">
                      <el-col :lg="8"><div>{{$t('plate.3')}}:</div></el-col>
                        <el-col>
                          <el-select v-model="editPlateQuality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                            <el-option v-for="item in plateQualities" :key="item.value" :label="item.label" :value="item.value" :disabled = "item.value===-1||item.value===0">
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col>
                            配置权重:
                        </el-col>
                        <el-input-number v-model="editPlateQualityChance" :precision="2" :step="0.1" placeholder="请输入权重" ></el-input-number>
                        <el-button @click="addPlateQualityCustomizeTags">添加权重</el-button>
                        <el-row>
                          <el-col>
                            结果集:
                          </el-col>
                          <el-tag v-for="(tag,idx) in plateQualityCustomizeTags" :key="idx" closable @close="deletePlateQualityCustomizeTags(idx)">{{$t(tag.data.label)}}-{{tag.chance}}</el-tag>
                        </el-row>
                    </div>
                </el-row>
                  <el-divider></el-divider>
                  <el-row>
                      <!-- 重量 -->
                      <el-col :lg="8">
                          <div>{{$t('plate.1')}}:</div>
                      </el-col>
                    <el-col v-if="plateQuality === -1">
                      <el-select v-model="plateWeight" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                        <el-option v-for="item in plateWeights[0]" :key="item.value" :label="$t(item.label)" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                      <el-col v-if="plateQuality === 1">
                          <el-select v-model="plateWeight" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                              <el-option v-for="item in plateWeights[1]" :key="item.value" :label="$t(item.label)" :value="item.value">
                              </el-option>
                          </el-select>
                      </el-col>
                      <el-col v-if="plateQuality === 2">
                          <el-select v-model="plateWeight" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                              <el-option v-for="item in plateWeights[2]" :key="item.value" :label="$t(item.label)" :value="item.value">
                              </el-option>
                          </el-select>
                      </el-col>
                      <el-col v-if="plateQuality === 3">
                          <el-select v-model="plateWeight" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                              <el-option v-for="item in plateWeights[3]" :key="item.value" :label="$t(item.label)" :value="item.value">
                              </el-option>
                          </el-select>
                      </el-col>
                      <el-col v-if="plateQuality === 4 || plateQuality === 0">
                          <el-select v-model="plateWeight" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                              <el-option v-for="item in plateWeights[4]" :key="item.value" :label="$t(item.label)" :value="item.value">
                              </el-option>
                          </el-select>
                      </el-col>
                  </el-row>
                  <el-divider></el-divider>
                  <el-row>
                      <!-- 技能数量 -->
                      <el-col :lg="8">
                          <div>{{$t('plate.2')}}:</div>
                      </el-col>
                      <el-col>
                          <el-select v-model="plateSkillNum" filterable default-first-option :placeholder='$t("reward_editor.2")' value=0>
                              <el-option v-for="item in plateSkillNumOptions" :key="item.value" :label="$t(item.label)" :value="item.value">
                              </el-option>
                          </el-select>
                      </el-col>
                  </el-row>
                  <el-divider></el-divider>
                  <el-row v-if="plateSkillNum===1||plateSkillNum===2">
                      <el-col>技能1：</el-col>
                      <el-select v-model="plateConfigOption1" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                          <el-option v-for="item in plateConfigOptions" :key="item.value" :label="$t(item.label)" :value="item.value" :disabled="item.value===-1">
                          </el-option>
                      </el-select>
                      <div v-if="plateConfigOption1===1">
                          <el-col>
                              选择技能效果:
                          </el-col>
                          <el-select v-model="plateConfig1" filterable :placeholder='$t("reward_editor.2")' value="">
                              <el-option v-for="item in plateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                              </el-option>
                          </el-select>
                      </div>
                      <div v-if="plateConfigOption1===2">
                          <div>
                              <el-col>
                                  选择技能效果:
                              </el-col>
                              <el-select v-model="plateConfig1" filterable :placeholder='$t("reward_editor.2")' value="">
                                  <el-option v-for="item in plateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                  </el-option>
                              </el-select>
                          </div>
                          <div>
                              <el-col>
                                  配置权重:
                              </el-col>
                              <el-input-number v-model="editPlateChance1" :precision="2" :step="0.1" placeholder="请输入权重" ></el-input-number>
                          </div>
                          <el-button @click="addPlateCustomizeTags1">添加权重</el-button>
                          <div>
                              <el-col>
                                  结果集:
                              </el-col>
                              <el-tag v-for="(tag,idx) in plateCustomizeTags1" :key="idx" closable @close="deletePlateCustomizeTags1(idx)">{{$t(tag.data.name)}}-{{tag.chance}}</el-tag>
                          </div>
                      </div>
                  </el-row>
                  <el-divider></el-divider>
                  <el-row v-if="plateSkillNum===2">
                      <el-col>技能2：</el-col>
                      <el-select v-model="plateConfigOption2" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                          <el-option v-for="item in plateConfigOptions" :key="item.value" :label="$t(item.label)" :value="item.value">
                          </el-option>
                      </el-select>
                      <div v-if="plateConfigOption2===1">
                          <el-col>
                              选择技能效果:
                          </el-col>
                          <el-select v-model="plateConfig2" filterable :placeholder='$t("reward_editor.2")' value="">
                              <el-option v-for="item in plateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                              </el-option>
                          </el-select>
                      </div>
                      <div v-if="plateConfigOption2===2">
                          <div>
                              <el-col>
                                  选择技能效果:
                              </el-col>
                              <el-select v-model="plateConfig2" filterable :placeholder='$t("reward_editor.2")' value="">
                                  <el-option v-for="item in plateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                  </el-option>
                              </el-select>
                          </div>
                          <div>
                              <el-col>
                                  配置权重:
                              </el-col>
                              <el-input-number v-model="editPlateChance2" :precision="2" :step="0.1" placeholder="请输入权重" ></el-input-number>
                          </div>
                          <el-button @click="addPlateCustomizeTags2">添加权重</el-button>
                          <div>
                              <el-col>
                                  结果集:
                              </el-col>
                              <el-tag v-for="(tag,idx) in plateCustomizeTags2" :key="idx" closable @close="deletePlateCustomizeTags2(idx)">{{$t(tag.data.name)}}-{{tag.chance}}</el-tag>
                          </div>
                      </div>
                  </el-row>
              </div>
            </div>

            <div v-if="optionValue == '18'">
                <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp18" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
                <el-divider></el-divider>
                <el-row>
                    <!--等级-->
                    <el-col :lg="4">
                        <div>{{$t('reward_editor.7')}}:
                            <el-input-number v-model="editEmblemBox.level" :min="1" :max="100" :label="$t('reward_editor.8')" @change="onEmblemBoxLevelChange"></el-input-number>
                        </div>
                    </el-col>
                    <!--阶段-->
                    <el-col :lg="4">
                        <div>{{$t('reward_editor.9')}}:
                            <el-input-number v-model="editEmblemBox.sage" :min="0" :max="20" :disabled="true" :label="$t('reward_editor.10')"></el-input-number>
                        </div>
                    </el-col>
                    <!--品质-->
                    <el-col :lg="4">
                        <div>{{$t('reward_editor.6')}}:
                            <el-select v-model="editEmblemBox.quality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="" @change="onEmblemBoxQualityChange">
                                <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                    </div>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                    <!--主属性-->
                    <el-col>
                        <div>
                            <el-col>
                                选择主属性效果:
                            </el-col>
                            <el-select v-model="editEmblemBox.editEmblemMainProperty" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                                <el-option v-for="item in emblemMainConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <el-col>
                                指定主属性品质:
                            </el-col>
                            <el-select v-model="editEmblemBox.editEmblemMainQuality" filterable :placeholder='$t("reward_editor.2")' value=0>
                                <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <el-col>
                                指定浮动值:
                            </el-col>
                            <el-input-number v-model="editEmblemBox.editEmblemMainRdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0></el-input-number>
                        </div>
                        <el-button @click="addEmblemBoxTag('main')">添加权重</el-button>
                        <el-row>
                            <el-col>
                                结果集:
                            </el-col>
                            <el-tag v-for="(tag,idx) in editEmblemBox.mainTags" :key="idx" closable @close="deleteEmblemBoxTag(idx,'main')">{{$t(tag.data.name)}}-{{tag.quality}}-{{tag.rdFloat}}</el-tag>
                        </el-row>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
                <!--宿命-->
                <el-row>
                    <el-col>
                        <div>
                            <el-col>
                                选择宿命属性效果:
                            </el-col>
                            <el-select v-model="editEmblemBox.editEmblemFateProperty" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                                <el-option v-for="item in emblemFateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <el-col>
                                指定宿命属性品质:
                            </el-col>
                            <el-select v-model="editEmblemBox.editEmblemFateQuality" filterable :placeholder='$t("reward_editor.2")' value=0>
                                <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <el-col>
                                指定浮动值:
                            </el-col>
                            <el-input-number v-model="editEmblemBox.editEmblemFateRdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0></el-input-number>
                        </div>
                        <el-button @click="addEmblemBoxTag('fate')">添加权重</el-button>
                        <el-row>
                            <el-col>
                                结果集:
                            </el-col>
                            <el-tag v-for="(tag,idx) in editEmblemBox.fateTags" :key="idx" closable @close="deleteEmblemBoxTag(idx,'fate')">{{$t(tag.data.name)}}-{{tag.quality}}-{{tag.rdFloat}}</el-tag>
                        </el-row>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
                <!--词条-->
                <el-row>
                  <el-col>
                    玩家可自选词条数量:
                  </el-col>
                  <el-input-number v-model="editEmblemBox.chooseEntryNum" :min="1" :max="editEmblemBox.quality" label="可选词条数量"></el-input-number>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                    <el-col>
                        <div>
                            <el-col>
                                选择词条属性效果:
                            </el-col>
                            <el-cascader v-model="editEmblemBox.editEmblemEntryProperty" :options="emblemEntryConfigs">
                                <template slot-scope="{ node, data }">
                                    <span>{{ data.label }}</span>
                                    <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                </template>
                            </el-cascader>
                        </div>
                        <div>
                            <el-col>
                                指定词条属性品质:
                            </el-col>
                            <el-select v-model="editEmblemBox.editEmblemEntryQuality" filterable :placeholder='$t("reward_editor.2")' value=0>
                                <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <el-col>
                                指定浮动值:
                            </el-col>
                            <el-input-number v-model="editEmblemBox.editEmblemEntryRdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0></el-input-number>
                        </div>

                        <el-button @click="addEmblemBoxTag('entry')">添加权重</el-button>
                        <el-row>
                            <el-col>
                                词条结果集:
                            </el-col>
                            <el-tag v-for="(tag,idx) in editEmblemBox.entryTags" :key="idx" closable @close="deleteEmblemBoxTag(idx,'entry')">{{$t(tag.data.label)}}-{{tag.quality}}-{{tag.rdFloat}}</el-tag>
                        </el-row>

                    </el-col>
                </el-row>
                <el-divider></el-divider>
            </div>

            <div v-if="optionValue == '19'">
                <el-select v-model="value" filterable default-first-option placeholder='进化光谱'>
                    <el-option v-for="item in arrProp19" :key="item.id + 70000" :label="(item.id + 70000) +'-' + $t(item.name) + '的进化光谱'"
                               :value="item.id + 70000">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+(item.id + 70000)+'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) + '的进化光谱' }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '20'">
                <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp20" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '21'">
                <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp21" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '22'">
                <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp22" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </div>

            <div v-if="optionValue == '23'">
                <el-select v-model="value" filterable default-first-option :placeholder='$t("reward_editor.2")'>
                    <el-option v-for="item in arrProp23" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
                <el-divider></el-divider>
                <el-row>
                    <!--品质-->
                    <el-col>
                        <div>{{$t('reward_editor.6')}}:
                            <el-select v-model="editEmblemBook.quality" filterable default-first-option :placeholder='$t("reward_editor.2")' value="" @change="onEmblemBoxQualityChange">
                                <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <!--浮动值-->
                    <el-col>
                        指定浮动值:
                        <el-input-number v-model="editEmblemBook.rdFloat" filterable :step="0.01" :placeholder='$t("reward_editor.2")' value=0></el-input-number>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                    <el-col>
                        <div>类型:
                            <el-select v-model="editEmblemBook.type" filterable default-first-option :placeholder='$t("reward_editor.2")' @change="onEmblemBoxQualityChange">
                                <el-option v-for="item in editEmblemBook.propertyOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col v-if="editEmblemBook.type === 'entry'">
                        选择词条属性效果:
                        <el-cascader v-model="editEmblemBook.editEmblemEntryProperty" :options="emblemEntryConfigs">
                            <template slot-scope="{ node, data }">
                                <span>{{ data.label }}</span>
                                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                            </template>
                        </el-cascader>
                    </el-col>
                    <el-col v-if="editEmblemBook.type === 'fate'">
                        选择宿命属性效果:
                        <el-select v-model="editEmblemBook.editEmblemFateProperty" filterable default-first-option :placeholder='$t("reward_editor.2")' value="">
                            <el-option v-for="item in emblemFateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
            </div>

        </el-form-item>
    </el-form>
</template>

<script>
    import commonApi from '../service/common_api.js'
    import {
        mapState
    } from 'vuex';

    export default {
        name: "component_sub_reward",
        data() {
            return {
                value: "",
                arrProp0: [],
                arrProp3: [],
                arrProp4: [],
                arrProp6: [],
                arrProp7: [],
                arrProp9: [],
                arrProp10: [],
                arrProp11: [],
                arrProp12: [],
                arrProp13: [],
                arrProp14: [],
                arrProp15: [],
                arrProp17: [],
                arrProp18: [],
                arrProp19: [],
                arrProp20: [],
                arrProp21: [],
                arrProp22: [],
                arrProp23: [],
                arrConditionProp:[],
                monsterConfigs: [],
                propConfig: [],
                emblemEffectConfig: [],
                godConfigs: [],
                wallGainType: [],
                skinGainType: [],
                emblemMainConfigs: [],
                emblemFateConfigs: [],
                emblemEntryConfigs: [],
                emblemRandomByQuality:false,
                emblemMainProperty: 1,
                emblemFateProperty: 51,
                emblemLevel: 1,
                emblemStage: 0,
                emblemQuality: 1,
                emblemFateOptions:[{
                    value: 0,
                    label: this.$t("reward_editor.48")
                },{
                    value: 2,
                    label: this.$t("reward_editor.50")
                },{
                    value: 3,
                    label: this.$t("reward_editor.53")
                },{
                    value: -1,
                    label: this.$t("reward_editor.51")
                }],
                emblemFate:0,
                emblemFateCustomizeTags:[],
                emblemFateCustomize:100,
                editEmblemFateChance:0,
                editEmblemFateProperty: 51,
                editEmblemFateQuality: 0,
                editEmblemFateRdFloat: 0,
                emblemQualities: [{
                    value: 0,
                    label: this.$t("reward_editor.48")
                },{
                    value: 1,
                    label: this.$t("reward_editor.31")
                },
                    {
                        value: 2,
                        label: this.$t("reward_editor.32")
                    },
                    {
                        value: 3,
                        label: this.$t("reward_editor.33")
                    },
                    {
                        value: 4,
                        label: this.$t("reward_editor.34")
                    },
                    {
                        value: 5,
                        label: this.$t("reward_editor.35")
                    },
                    {
                        value: 6,
                        label: this.$t("reward_editor.36")
                    }
                ],
                editEmblemEntries:[
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:false
                    },
                ],
                wallGainQualityConfig: [
                    {id: 0,name: "白"},
                    {id: 1,name: "绿"},
                    {id: 2,name: "蓝"},
                    {id: 3,name: "紫"},
                    {id: 4,name: "橙"},
                    {id: 5,name: "红"},
                    {id: 100,name: "随机品质"},
                ],
                warGrooveQuality:0,
                warGrooveChannelSwitch: false,
                warGrooveChannelUp: 0,
                warGrooveChannelDown: 0,
                warGrooveChannelLeft: 0,
                warGrooveChannelRight: 0,
                warGrooveChannelOption: [
                    {id: 0,name: "不通"},
                    {id: 1,name: "通"},
                ],
                plateQuality:1,
                editPlateQuality:1,
                plateWeight:0,
                plateSkillNum:0,
                plateConfig1:0,
                plateConfigOption1:0,
                editPlateChance1:0,
                plateCustomizeTags1:[],
                plateConfig2:0,
                plateConfigOption2:0,
                editPlateChance2:0,
                plateCustomizeTags2:[],
                editPlateQualityChance:0,
                plateQualityCustomizeTags:[],
                plateConfigs:[],
                plateQualities:[
                    {value: -1,label: "自定权重"},
                    {value: 0,label: "随机品质"},
                    {value: 1,label: "蓝"},
                    {value: 2,label: "紫"},
                    {value: 3,label: "橙"},
                    {value: 4,label: "红"}
                ],
                plateSkillNumOptions:[
                    {
                      value: 0,
                      label:"随机"
                    },
                    {
                      value: 1,
                      label:"单技能"
                    },
                    {
                      value: 2,
                      label:"双技能"
                    },

                ],
                plateWeights:{
                    0:[
                        {value: 0,label: "随机重量"},
                        {value: 3,label: "重量三"},
                        {value: 4,label: "重量四"},
                        {value: 5,label: "重量五"},
                        {value: 6,label: "重量六"},
                        {value: 7,label: "重量七"}
                    ],
                    1:[
                        {value: 0,label: "随机重量"},
                        {value: 3,label: "重量三"},
                        {value: 4,label: "重量四"}
                    ],
                    2:[
                        {value: 0,label: "随机重量"},
                        {value: 4,label: "重量四"},
                        {value: 5,label: "重量五"}
                    ],
                    3:[
                        {value: 0,label: "随机重量"},
                        {value: 5,label: "重量五"},
                        {value: 6,label: "重量六"}
                    ],
                    4:[
                        {value: 0,label: "随机重量"},
                        {value: 5,label: "重量五"},
                        {value: 7,label: "重量七"}
                    ],
                },
                plateConfigOptions:[
                    {
                        value: 0,
                        label:"随机"
                    },
                    {
                        value: 1,
                        label:"指定"
                    },
                    {
                        value: 2,
                        label:"自定义"
                    },
                    {
                        value: -1,
                        label:"必不出"
                    },
                ],
                editEmblemBox:{
                    level:1,
                    sage:0,
                    quality:1,
                    editEmblemMainProperty: 1,
                    editEmblemMainQuality: 0,
                    editEmblemMainRdFloat: 0,
                    mainTags:[],
                    editEmblemFateProperty: 51,
                    editEmblemFateQuality: 0,
                    editEmblemFateRdFloat: 0,
                    fateTags:[],
                    chooseEntryNum:1,
                    editEmblemEntryProperty: [3, 0],
                    editEmblemEntryQuality: 0,
                    editEmblemEntryRdFloat: 0,
                    entryTags:[]
                },
                editEmblemBook:{
                    quality:1,
                    rdFloat:0,
                    type:'entry',
                    editEmblemFateProperty: 51,
                    editEmblemEntryProperty: [3, 0],
                    propertyOptions:[
                        {
                            value: "entry",
                            label:"词条"
                        },
                        {
                            value: "fate",
                            label:"宿命"
                        },
                    ]
                }
            }
        },
        props: ['optionValue', 'confirmFinal', 'currentReward'],
        created() {
            this.initData();
        },
        watch:{
            optionValue(n, l) {
                if (n!==l) {
                    this.value = '';
                }
            },

            confirmFinal() {
                if (this.confirmFinal) {
                    this.deliverNumberValue();
                }
            },

            currentReward(n, l) {
                if (n!==l) {
                    this.resolveRewardStr(this.currentReward);
                }
            },
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        methods: {
            initData: function() {
                let self = this;
                let tables = 'monster_config,war_groove_config,skin_config,god_config,emblem_effect_config,prop_config,plate_origin_config';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.monsterConfigs = [];
                    self.propConfig = res.prop_config;
                    self.emblemEffectConfig = res.emblem_effect_config;
                    self.godConfigs = res.god_config;
                    self.wallGainType = res.war_groove_config;
                    self.skinGainType = res.skin_config;

                    res.monster_config.forEach(configItem=>{
                        if (configItem.special === 0){
                            self.monsterConfigs.push(configItem);
                        }
                    })


                    let arrProp0 = [];
                    let arrProp3 = [];
                    let arrProp4 = [];
                    let arrConditionProp = [];
                    let arrProp9 = [];
                    let arrProp10 = [];
                    let arrProp11 = [];
                    let arrProp12 = [];
                    let arrProp13 = [];
                    let arrProp14 = [];
                    let arrProp15 = [];
                    let arrProp17 = [];
                    let arrProp18 = [];
                    let arrProp20 = [];
                    let arrProp21 = [];
                    let arrProp22 = [];
                    let arrProp23 = [];
                    res.prop_config.forEach(function(item) {
                        let type = item.big_type;
                        if (type == 0) {
                            arrProp0.push(item);
                        } else if (type == 3) {
                            arrProp3.push(item);
                        }  else if (type == 5) {
                            arrConditionProp.push(item);
                        }else if (type == 9) {
                            arrProp9.push(item);
                        }else if(type == 4){
                            arrProp4.push(item);
                        } else if (type == 10) {
                            arrProp10.push(item)
                        } else if (type == 11) {
                            arrProp11.push(item)
                        } else if (type == 12) {
                            arrProp12.push(item)
                        } else if (type == 13) {
                            arrProp13.push(item)
                        } else if (type == 14) {
                            arrProp14.push(item)
                        } else if (type == 15) {
                            arrProp15.push(item)
                        } else if (type === 17){
                            arrProp17.push(item)
                        } else if (type === 18){
                            arrProp18.push(item)
                        }  else if (type === 20){
                            arrProp20.push(item)
                        } else if (type === 21){
                            arrProp21.push(item)
                        } else if (type === 22){
                            arrProp22.push(item)
                        } else if (type == 23) {
                            arrProp23.push(item)
                        }
                    });
                    self.arrProp0 = arrProp0;
                    self.arrProp3 = arrProp3;
                    self.arrProp4 = arrProp4;
                    self.arrConditionProp = arrConditionProp;
                    //元核属性类型: 0-主属性;1-二字词条;2-四字词条;3-宿命
                    let tw = {
                        value: 1,
                        label: this.$t("reward_editor.37"),
                        children: []
                    };
                    let fw = {
                        value: 2,
                        label: this.$t("reward_editor.38"),
                        children: []
                    };
                    let special = {
                        value: 3,
                        label: this.$t("reward_editor.52"),
                        children: [{
                            value: 0,
                            label: this.$t("reward_editor.48"),
                        }]
                    }

                    let twConfigs = [];
                    let fwConfigs = [];
                    res.emblem_effect_config.forEach(function(item) {
                        if (item.type === 0) {
                            self.emblemMainConfigs.push(item);
                        } else if (item.type === 1) {
                            twConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type === 2) {
                            fwConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type === 3) {
                            self.emblemFateConfigs.push(item);
                        }
                    });
                    tw.children = twConfigs;
                    fw.children = fwConfigs;
                    self.emblemEntryConfigs.push(tw);
                    self.emblemEntryConfigs.push(fw);
                    self.emblemEntryConfigs.push(special);
                    self.arrProp9 = arrProp9;
                    self.arrProp10 = arrProp10;
                    self.arrProp11 = arrProp11;
                    self.arrProp12 = arrProp12;
                    self.arrProp13 = arrProp13;
                    self.arrProp14 = arrProp14;
                    self.arrProp15 = arrProp15;

                    let arrProp6 = [];
                    self.monsterConfigs.forEach(function(item) {
                        let monsterRace = item.race;
                        let monsterQuality = item.quality;
                        if (monsterQuality === 4 && monsterRace.indexOf("_") > -1) {
                            arrProp6.push(item);
                        }
                    });
                    self.arrProp6 = arrProp6;

                    let arrProp19 = [];
                    self.monsterConfigs.forEach(function(item) {
                        let hyperEvolution = item.hyper_evolution;
                        if (hyperEvolution === 1) {
                            arrProp19.push(item);
                        }
                    });
                    self.arrProp19 = arrProp19;

                    let arrProp7 = [];
                    res.war_groove_config.forEach(function(item) {
                        let type = item.type;
                        if (type === 3 || type === 4) {
                            arrProp7.push(item);
                        }
                    });
                    self.arrProp7 = arrProp7;

                    self.arrProp17 = arrProp17;

                    res.plate_origin_config.forEach(function(item) {
                        self.plateConfigs.push({
                            id: item.id,
                            name: self.$t(item.name) + '('+self.$t(item.description)+')'
                        });
                    });

                    self.arrProp18 = arrProp18;
                    self.arrProp20 = arrProp20;
                    self.arrProp21 = arrProp21;
                    self.arrProp22 = arrProp22;
                    self.arrProp23 = arrProp23;
                    //self.glyphFateType = arr2;
                })
            },
            addEmblemEntry() {
                let self = this;
                //TODO 重写
            },
            removeEmblemEntry() {
                let self = this;
                //TODO 重写
            },
            //元核等级变化
            onEmblemLevelChange(){
                let self = this;
                let level = self.emblemLevel;
                self.emblemStage = Math.floor(level / 5);
            },
            onEmblemQualityChange(){
                let self = this;
                let quality = self.emblemQuality;

                for(let i=0;i<self.editEmblemEntries.length;i++){
                    if(i<quality){
                        self.editEmblemEntries[i].active = true;
                    }else{
                        self.editEmblemEntries[i].active = false;
                    }
                }
            },
            onEmblemTypeChange(){
                let self = this;
                if(self.value===50001){
                    self.emblemRandomByQuality = false;
                }else{
                    self.emblemRandomByQuality = true;
                }
            },
            addEmblemFateChance(){
                let self = this;
                let temp;
                for(let i=0;i<self.emblemFateConfigs.length;i++){
                    if(self.emblemFateConfigs[i].id===self.editEmblemFateProperty){
                        temp = self.emblemFateConfigs[i];
                    }
                }
                self.emblemFateCustomizeTags.push({id:self.editEmblemFateProperty,data:temp,chance:self.editEmblemFateChance,quality:self.editEmblemFateQuality,rdFloat:self.editEmblemFateRdFloat});
            },
            addEmblemBoxTag(type){
                let self = this;
                let box = self.editEmblemBox;
                let temp;

                switch (type){
                    case "main":
                        for(let i=0;i<self.emblemMainConfigs.length;i++){
                            if(self.emblemMainConfigs[i].id===box.editEmblemMainProperty){
                                temp = self.emblemMainConfigs[i];
                            }
                        }
                        box.mainTags.push({id:box.editEmblemMainProperty,data:temp,quality:box.editEmblemMainQuality,rdFloat:box.editEmblemMainRdFloat});
                        break;
                    case "fate":
                        for(let i=0;i<self.emblemFateConfigs.length;i++){
                            if(self.emblemFateConfigs[i].id===box.editEmblemFateProperty){
                                temp = self.emblemFateConfigs[i];
                            }
                        }
                        box.fateTags.push({id:box.editEmblemFateProperty,data:temp,quality:box.editEmblemFateQuality,rdFloat:box.editEmblemFateRdFloat});
                        break;
                    case "entry":
                        self.emblemEntryConfigs[box.editEmblemEntryProperty[0]-1].children.forEach(item => {
                            if(item.value===box.editEmblemEntryProperty[1]){
                                temp = item;
                            }
                        });

                        box.entryTags.push({id:box.editEmblemEntryProperty[1],data:temp,quality:box.editEmblemEntryQuality,rdFloat:box.editEmblemEntryRdFloat});
                        break;
                }
            },
            deleteEmblemBoxTag(idx,type){
                let self = this;
                let box = self.editEmblemBox;
                switch (type) {
                    case "main":
                        box.mainTags.splice(idx,1);
                        break;
                    case "fate":
                        box.fateTags.splice(idx,1);
                        break;
                    case "entry":
                        box.entryTags.splice(idx,1);
                        break;
                }
            },
            deleteEmblemFateChance(idx){
                let self = this;
                self.emblemFateCustomizeTags.splice(idx,1);
            },

            resolveRewardStr(str){
                let self = this;

                if (str == '') {
                    self.countSwitch = false;
                    self.rateSwitch = false;
                    self.isDetail = false;
                    self.count1 = 1;
                    self.count2 = 1;
                    self.rate = 0.1;
                    self.emblemLevel = 1;
                    self.emblemStage = 0;
                    self.emblemQuality = 1;
                    self.emblemMainProperty = 1;
                    self.emblemFate = 0;
                    self.emblemFateCustomize = 100;
                    self.emblemFateProperty = 51;
                    self.editEmblemFateQuality = 0;
                    self.editEmblemFateRdFloat = 0;

                    self.editEmblemEntries = [
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:true
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            rdFloat:0,
                            active:false
                        },
                    ]
                }

                let rewardArray = str.toString().split("_");

                for (let index = 0; index < rewardArray.length; index++) {
                    const element = rewardArray[index];
                    switch (index) {
                        case 0:
                            let bigTypeArry = element.split("$");
                            //大类
                            self.optionValue = bigTypeArry[0];
                            //identify
                            self.value = parseInt(bigTypeArry[1]);
                            self.emblemRandomByQuality = self.value !== 50001;
                            break;
                        case 1:
                            //数量
                            let countArry = element.split("-");
                            if(countArry.length>1){
                                self.countSwitch = true;
                                self.count1 = countArry[0];
                                let rateAndCount = countArry[1].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count2 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count2 = countArry[1];
                                }
                            }else{
                                self.countSwitch = false;

                                let rateAndCount = countArry[0].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count1 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count1 = countArry[0];
                                }
                            }
                            break;
                        case 2:
                            if(self.optionValue === '4'){
                                //等级
                                self.emblemLevel = parseInt(element);
                            }else if (self.optionValue === '7') {
                                self.warGrooveQuality = parseInt(element);
                            }else if(self.optionValue === '17'){
                                //起源盘品质
                              let qualityArray = element.split("#");
                              if(qualityArray.length>=1 && qualityArray[0].split("@").length>1){
                                self.plateQuality = -1;
                                for (let i = 0; i < qualityArray.length; i++) {
                                  let item = qualityArray[i].split("@");
                                  for(let j=0;j<self.plateQualities.length;j++){
                                    if(self.plateQualities[j].value===parseInt(item[0])){
                                      self.plateQualityCustomizeTags[i] = {value:item[0],chance:item[1],data:self.plateQualities[j]}
                                    }
                                  }
                                }

                              }else{
                                  self.plateQuality = parseInt(element);
                              }
                            }
                            break;
                        case 3:
                            if(self.optionValue === '4'){
                                //阶段
                                self.emblemStage = parseInt(element);
                            }else if (self.optionValue === '7') {
                                if (element) {
                                    self.warGrooveChannelSwitch = true;
                                    self.warGrooveChannelUp = parseInt(element);
                                } else {
                                    self.warGrooveChannelSwitch = false;
                                }
                            }else if(self.optionValue === '17'){
                                self.plateWeight = parseInt(element);
                            }
                            break;
                        case 4:
                            if(self.optionValue === '4'){
                                //品质
                                self.emblemQuality = parseInt(element);
                            }else if (self.optionValue === '7') {
                                self.warGrooveChannelDown = parseInt(element);
                            }else if(self.optionValue === '17'){
                                self.plateSkillNum = parseInt(element);
                            }
                            break;
                        case 5:
                            if(self.optionValue === '4'){
                                //宿命
                                let fateArray = element.split("#");
                                if(fateArray.length>=1 && fateArray[0].split("@").length>1){
                                    self.emblemFate = 3;
                                    for (let i = 0; i < fateArray.length; i++) {
                                        let item = fateArray[i].split("@");
                                        for(let j=0;j<self.emblemFateConfigs.length;j++){
                                            if(self.emblemFateConfigs[j].id==parseInt(item[0])){
                                                self.emblemFateCustomizeTags[i] = {id:item[0],chance:item[1],quality:item[2],rdFloat:parseFloat(item[3]),data:self.emblemFateConfigs[j]}
                                            }
                                        }
                                    }
                                }else{
                                    if(element>0){
                                        self.emblemFate = 2;
                                        self.emblemFateProperty = parseInt(element);
                                    }else{
                                        self.emblemFate = 0;
                                    }
                                }
                            }else if (self.optionValue === '7') {
                                self.warGrooveChannelLeft = parseInt(element);
                            }else if(self.optionValue === '17'){
                              let skillArray = element.split("#");
                              if(skillArray.length>=1 && skillArray[0].split("@").length>1){
                                self.plateConfigOption1 = 2;
                                for (let i = 0; i < skillArray.length; i++) {
                                  let item = skillArray[i].split("@");
                                  for(let j=0;j<self.plateConfigs.length;j++){
                                    if(self.plateConfigs[j].id===parseInt(item[0])){
                                      self.plateCustomizeTags1[i] = {id:item[0],chance:item[1],data:self.plateConfigs[j]}
                                    }
                                  }
                                }

                              }else{
                                if(element>0){
                                  self.plateConfigOption1 = 1;
                                  self.plateConfig1 = parseInt(element);
                                }
                              }
                            }

                            break;
                        case 6:
                            if(self.optionValue === '4'){
                                //宿命自定义概率
                                self.emblemFateCustomize = parseInt(element*100);
                            }else if (self.optionValue === '7') {
                                self.warGrooveChannelRight = parseInt(element);
                            }else if(self.optionValue === '17'){
                              let skillArray = element.split("#");
                              if(skillArray.length>=1 && skillArray[0].split("@").length>1){
                                self.plateConfigOption2 = 2;
                                for (let i = 0; i < skillArray.length; i++) {
                                  let item = skillArray[i].split("@");
                                  for(let j=0;j<self.plateConfigs.length;j++){
                                    if(self.plateConfigs[j].id===parseInt(item[0])){
                                      self.plateCustomizeTags2[i] = {id:item[0],chance:item[1],data:self.plateConfigs[j]}
                                    }
                                  }
                                }

                              }else{
                                if(element>0){
                                  self.plateConfigOption2 = 1;
                                  self.plateConfig2 = parseInt(element);
                                }
                              }
                            }
                            break;
                        case 7:
                            if(self.optionValue === '4'){
                                //主属性
                                self.emblemMainProperty = parseInt(element);
                            }
                            break;
                        case 8:
                            if(self.optionValue === '4'){
                                //词条属性
                                let entryArray = element.split("#");
                                for (let index = 0; index < entryArray.length; index++) {
                                    const entryItem = entryArray[index];
                                    let current = self.editEmblemEntries[index];

                                    self.emblemEntryConfigs.forEach(item => {
                                        item.children.forEach(iitem => {
                                            if (iitem.value == entryItem.split('@')[0]&&entryItem.split('@').length>1) {
                                                current.entry = [item.value,iitem.value];
                                            }
                                        })
                                    })

                                    current.quality = parseInt(entryItem.split('@')[1]);
                                    current.rdFloat = entryItem.split('@')[2];
                                }

                                let countAndEntry = entryArray[entryArray.length-1].split('|');
                                if (countAndEntry.length>1) {
                                    self.rateSwitch = true;
                                    self.rate = countAndEntry[1];
                                } else {
                                    self.rateSwitch = false;
                                }
                                //强制刷新一次变量
                                // self.onEmblemQualityChange();
                                let quality = self.emblemQuality;

                                for(let i=0;i<self.editEmblemEntries.length;i++){
                                    if(i<quality){
                                        self.editEmblemEntries[i].active = true;
                                    }else{
                                        self.editEmblemEntries[i].active = false;
                                    }
                                }
                            }
                            break;
                        default:
                            break;
                    }
                }
            },

            deliverNumberValue() {
                let self = this;

                //条件串
                let conditionValue = '';

                //元核
                if (self.optionValue == 4) {
                    let emblemStr = "";
                    if(self.value == 50001){
                        emblemStr = self.emblemLevel + "_" + self.emblemStage + "_" + self.emblemQuality;
                        if (self.emblemFate == 0) {
                            emblemStr = emblemStr + "_" +self.emblemFate + "_-1";
                        }else if(self.emblemFate == 2) {
                            emblemStr = emblemStr + "_" + self.emblemFateProperty + "_1";
                        }else if(self.emblemFate == 3){
                            let temp = "";
                            if(self.emblemFateCustomizeTags.length>0){
                                for(let i = 0 ;i<self.emblemFateCustomizeTags.length;i++){
                                    let item = self.emblemFateCustomizeTags[i];
                                    temp = temp + item.id+"@"+item.chance+"@"+item.quality+"@"+item.rdFloat+"#";
                                }
                                temp = temp.slice(0,temp.length-1);
                            }else{
                                temp = "0";
                            }

                            emblemStr = emblemStr + "_" + temp + "_" + self.emblemFateCustomize/100;
                        }else if(self.emblemFate == -1){
                            emblemStr = emblemStr + "_" +self.emblemFate + "_-1";
                        }
                        emblemStr = emblemStr + "_" + self.emblemMainProperty+ "_";
                        //
                        for(let i=0;i<self.editEmblemEntries.length;i++){
                            let current = self.editEmblemEntries[i];
                            if(current.active === true){
                                emblemStr = emblemStr + current.entry[1] + "@" + current.quality+ "@" + current.rdFloat +"#";
                            }else{
                                emblemStr = emblemStr + "0#";
                            }
                        }
                        emblemStr = emblemStr.substr(0,emblemStr.length-1);
                    }
                    conditionValue = emblemStr;
                }
                else if(self.optionValue == 7){
                    if (self.warGrooveChannelSwitch) {
                        conditionValue = self.warGrooveQuality + '_' + self.warGrooveChannelUp + '_' + self.warGrooveChannelDown + '_' + self.warGrooveChannelLeft + '_' + self.warGrooveChannelRight
                    } else {
                        conditionValue = self.warGrooveQuality + '';
                    }
                }
                //起源盘
                else if(self.optionValue == 17){
                    let plateStr = "";
                    if(self.plateQuality===-1){
                      let temp = "";

                      if(self.plateQualityCustomizeTags.length>0){
                        for(let i = 0 ;i<self.plateQualityCustomizeTags.length;i++){
                          let item = self.plateQualityCustomizeTags[i];
                          temp = temp + item.value+"@"+item.chance+"#";
                        }
                        temp = temp.slice(0,temp.length-1);
                      }else{
                        temp = "0";
                      }
                      plateStr = temp;
                    }else{
                      plateStr = self.plateQuality
                    }

                    plateStr = plateStr + "_" + self.plateWeight+"_"+self.plateSkillNum;

                    if(self.plateSkillNum>0){
                        if(self.plateSkillNum===1){
                          if(self.plateConfigOption1 === 2){
                            let temp = "";

                            if(self.plateCustomizeTags1.length>0){
                              for(let i = 0 ;i<self.plateCustomizeTags1.length;i++){
                                let item = self.plateCustomizeTags1[i];
                                temp = temp + item.id+"@"+item.chance+"#";
                              }
                              temp = temp.slice(0,temp.length-1);
                            }else{
                              temp = "0";
                            }
                            plateStr = plateStr + "_" +temp;
                          }else {
                            plateStr = plateStr + "_" +self.plateConfig1;
                          }

                          plateStr = plateStr + "_0";
                        }else if(self.plateSkillNum===2){
                          if(self.plateConfigOption1 === 2){
                            let temp = "";

                            if(self.plateCustomizeTags1.length>0){
                              for(let i = 0 ;i<self.plateCustomizeTags1.length;i++){
                                let item = self.plateCustomizeTags1[i];
                                temp = temp + item.id+"@"+item.chance+"#";
                              }
                              temp = temp.slice(0,temp.length-1);
                            }else{
                              temp = "0";
                            }
                            plateStr = plateStr + "_" +temp;
                          }else {
                            plateStr = plateStr + "_" +self.plateConfig1;
                          }
                          if(self.plateConfigOption2 === 2){
                            let temp = "";
                            if(self.plateCustomizeTags2.length>0){
                              for(let i = 0 ;i<self.plateCustomizeTags2.length;i++){
                                let item = self.plateCustomizeTags2[i];
                                temp = temp + item.id+"@"+item.chance+"#";
                              }
                              temp = temp.slice(0,temp.length-1);
                            }else{
                              temp = "0";
                            }
                            plateStr = plateStr + "_" +temp;
                          }else {
                            plateStr = plateStr + "_" +self.plateConfig2;
                          }
                        }

                    }else {
                      plateStr = plateStr + "_0_0";
                    }

                    conditionValue = plateStr;
                }
                //自选元核箱
                else if(self.optionValue == 18){
                    let box = self.editEmblemBox;
                    let emblemBoxStr = box.level + "_" + box.sage + "_" + box.quality;

                    if(box.mainTags.length>0){
                        let temp = "";
                        box.mainTags.forEach(item =>{
                            temp = temp + item.id + "@" + item.quality +"@"+ item.rdFloat+"#";
                        });
                        temp = temp.slice(0,temp.length-1);

                        emblemBoxStr = emblemBoxStr + "_" +temp;
                    }else{
                        emblemBoxStr = emblemBoxStr + "_0@0@0";
                    }

                    if(box.fateTags.length>0){
                        let temp = "";
                        box.fateTags.forEach(item =>{
                            temp = temp + item.id + "@" + item.quality +"@"+ item.rdFloat+"#";
                        });
                        temp = temp.slice(0,temp.length-1);

                        emblemBoxStr = emblemBoxStr + "_" +temp;
                    }else{
                        emblemBoxStr = emblemBoxStr + "_0@0@0";
                    }

                    if(box.entryTags.length>0){
                        let temp = "";
                        box.entryTags.forEach(item =>{
                            temp = temp + item.id + "@" + item.quality +"@"+ item.rdFloat+"#";
                        });
                        temp = temp.slice(0,temp.length-1);

                        emblemBoxStr = emblemBoxStr + "_" +temp;
                    }else{
                        emblemBoxStr = emblemBoxStr + "_0@0@0";
                    }

                    //最后添加可自选词条数量
                  emblemBoxStr = emblemBoxStr + "_"+box.chooseEntryNum;

                    conditionValue = emblemBoxStr;
                }
                else if(self.optionValue == 23){
                    let book = self.editEmblemBook;
                    let emblemBookStr = book.quality + "_" + book.rdFloat;

                    if(book.type === 'entry'){
                        emblemBookStr = emblemBookStr +"_"+book.editEmblemEntryProperty[0]+ "_"+book.editEmblemEntryProperty[1];
                    }else{
                        emblemBookStr = emblemBookStr +"_3_"+book.editEmblemFateProperty;
                    }

                    conditionValue = emblemBookStr;
                }

                this.$emit('conditionValue',conditionValue)
                this.$emit('value',self.value)
            },

            //起源盘相关方法
            addPlateCustomizeTags1(){
                let self = this;
                let temp;
                for(let i=0;i<self.plateConfigs.length;i++){
                    if(self.plateConfigs[i].id===self.plateConfig1){
                        temp = self.plateConfigs[i];
                    }
                }
                self.plateCustomizeTags1.push({id:self.plateConfig1,data:temp,chance:self.editPlateChance1});
            },
            deletePlateCustomizeTags1(idx){
                let self = this;
                self.plateCustomizeTags1.splice(idx,1);
            },
            addPlateCustomizeTags2(){
                let self = this;
                let temp;
                for(let i=0;i<self.plateConfigs.length;i++){
                    if(self.plateConfigs[i].id===self.plateConfig2){
                        temp = self.plateConfigs[i];
                    }
                }
                self.plateCustomizeTags2.push({id:self.plateConfig2,data:temp,chance:self.editPlateChance2});
            },
            deletePlateCustomizeTags2(idx){
                let self = this;
                self.plateCustomizeTags2.splice(idx,1);
            },
            plateQualityChange(){
                this.plateWeight = 0;
            },
            addPlateQualityCustomizeTags(){
                let self = this;
                let temp;
                for(let i=0;i<self.plateQualities.length;i++){
                  if(self.plateQualities[i].value===self.editPlateQuality){
                     temp = self.plateQualities[i];
                  }
                }
                self.plateQualityCustomizeTags.push({value:self.editPlateQuality,data:temp,chance:self.editPlateQualityChance});
            },
            deletePlateQualityCustomizeTags(idx){
                let self = this;
                self.plateQualityCustomizeTags.splice(idx,1);
            },
            //监控元核箱子等级变化
            onEmblemBoxLevelChange(){
                let self = this;
                let level = self.editEmblemBox.level;
                self.editEmblemBox.sage = Math.floor(level / 5);
            },
            //监控元核箱子品质变化
            onEmblemBoxQualityChange(){
                let self = this;
                let quality = self.editEmblemBox.quality;

                /*for(let i=0;i<self.editEmblemEntries.length;i++){
                    self.editEmblemEntries[i].active = i < quality;
                }*/
            },
        }
    }
</script>

<style scoped>
    .float-tip {
        color: #E6A23C;
    }
</style>



// WEBPACK FOOTER //
// src/components/component_sub_reward.vue